module.exports = __webpack_public_path__ + "static/media/kitchen_printer.10bd7dd4.svg";